// src/features/customers/components/CustomerForm.jsx

import React from 'react';
import { TextInput, Textarea, Button, Spinner } from 'flowbite-react';
import ShowValidationMessage from '../../../components/ShowValidationMessage'; // Your reusable validation message component
import Label from "../../../components/Label"

import InputMask from 'react-input-mask';
/**
 * Reusable form component for creating and editing customer details.
 * It's a controlled component, meaning parent components manage the formData state.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.formData - The current state of the form data.
 * @param {Function} props.handleChange - Function to update formData on input change.
 * @param {Object} props.errors - An object containing field-specific error messages.
 * @param {boolean} props.loading - Indicates if the form is currently submitting.
 * @param {Function} props.onSubmit - Function to call when the form is submitted.
 * @param {string} props.submitButtonText - Text to display on the submit button.
 */
const CustomerForm = ({ formData, handleChange, errors, loading, handleSubmit, submitButtonText, submitButtonTextSubmitting }) => {

    const baseButtonClasses = `
  flex justify-end
  px-4 py-2.5
  text-base font-medium text-white
  rounded-lg
  shadow-sm
  bg-primary-brand
  hover:bg-primary-brand-darker
  transition ease-in-out duration-150
`;
    return (
        <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <Label htmlFor="firstName" label="First Name" />
                    <TextInput
                        id="firstName"
                        name="firstName"
                        type="text"
                        placeholder="John"
                        value={formData.firstName}
                        onChange={handleChange}
                        disabled={loading}
                        color={errors.firstName ? "failure" : "gray"}
                    />


                    <ShowValidationMessage error={errors.firstName} />

                </div>


                 <div>
                    <Label htmlFor="lastName" label="Last Name" />
                    <TextInput
                        id="lastName"
                        name="lastName"
                        type="text"
                        placeholder="Doe"
                        value={formData.lastName}
                        onChange={handleChange}
                        disabled={loading}
                        color={errors.lastName ? "failure" : "gray"}
                    />


                    <ShowValidationMessage error={errors.full_name} />

                </div>

                {/* Email */}
                <div>
                    <Label htmlFor="email" label="Email" />

                    <TextInput
                        id="email"
                        name="email"
                        type="email"
                        placeholder="john.doe@example.com"
                        value={formData.email}
                        onChange={handleChange}
                        disabled={loading}
                        color={errors.email ? "failure" : "gray"}
                    />


                    <ShowValidationMessage error={errors.email} />

                </div>

                {/* Phone */}
                <div>

                    <Label htmlFor="phone" label="Phone Number" />

                    <InputMask
                        mask="(999) 999-9999" // Defines the mask (9 is for any digit 0-9)
                        maskChar="_" // Placeholder character for empty digits
                        value={formData.phone}
                        onChange={handleChange}
                    >
                        {(inputProps) => (
                            <TextInput
                                {...inputProps} // Pass all InputMask's props to TextInput
                                id="phone"
                                name="phone"
                                type="tel" // Use type="tel" for phone numbers
                                placeholder="(123) 456-7890"
                                color={errors.phone ? 'failure' : 'gray'}
                                required={false} // Phone is optional in your current validation
                            />
                        )}
                    </InputMask>


                    <ShowValidationMessage error={errors.phone} />

                </div>

                {/* Address - Full width on small screens, one column on larger */}
                <div className="md:col-span-2">
                    <Label htmlFor="streetAddress" label="Street Address" />
                    <TextInput
                        id="streetAddress"
                        name="streetAddress"
                        className="placeholder-gray-500"
                        placeholder="Street Address"
                        rows={3}
                        value={formData.streetAddress}
                        onChange={handleChange}
                        disabled={loading}
                        color={errors.streetAddress ? "failure" : "gray"}
                    />


                    <ShowValidationMessage error={errors.address} />

                </div>

            <div className="grid grid-cols-3 md:grid-cols-3 gap-6">

                  <div>
                    <Label htmlFor="city" label="City" />
                    <TextInput
                        id="city"
                        name="city"
                        className="placeholder-gray-500"
                        placeholder="City"
                        rows={3}
                        value={formData.city}
                        onChange={handleChange}
                        disabled={loading}
                        color={errors.city ? "failure" : "gray"}
                    />


                    <ShowValidationMessage error={errors.city} />

                </div>


                <div>
                    <Label htmlFor="state" label="State" />
                    <TextInput
                        id="state"
                        name="state"
                        className="placeholder-gray-500"
                        placeholder="State"
                        rows={3}
                        value={formData.state}
                        onChange={handleChange}
                        disabled={loading}
                        color={errors.state ? "failure" : "gray"}
                    />


                    <ShowValidationMessage error={errors.state} />

                </div>

                <div>
                    <Label htmlFor="zipCode" label="Zip Code" />
                    <TextInput
                        id="zipCode"
                        name="zipCode"
                        className="placeholder-gray-500"
                        placeholder="Zip Code"
                        rows={3}
                        value={formData.zipCode}
                        onChange={handleChange}
                        disabled={loading}
                        color={errors.zipCode ? "failure" : "gray"}
                    />


                    <ShowValidationMessage error={errors.zipCode} />

                </div>
            </div>

                {/* Notes - Full width on small screens, one column on larger */}
                {/* <div className="md:col-span-2">
                    <Label htmlFor="notes" label="Notes (Optional)" />
                    <Textarea
                        id="notes"
                        name="notes"
                        className="placeholder-gray-500"
                        placeholder="Any additional notes about the customer..."
                        rows={4}
                        value={formData.notes}
                        onChange={handleChange}
                        disabled={loading}
                        color={errors.notes ? "failure" : "gray"} // Not strictly needed for nullable, but good for consistency
                    />


                    <ShowValidationMessage error={errors.notes} />

                </div> */}
            </div>

            <Button type="submit"  disabled={loading} className={`${baseButtonClasses} ml-auto`} >
                {loading ? (
                    <>
                        <Spinner size="sm" className="mr-3" />
                        {submitButtonTextSubmitting}
                    </>
                ) : (
                    submitButtonText
                )}
            </Button>
        </form>
    );
};

export default CustomerForm;
